import React from 'react';
import { ClockIcon, HeartIcon, ListIcon, SparklesIcon } from 'lucide-react';
export function ProductBenefits() {
  return <section className="bg-orange-50 py-8 sm:py-12 md:py-16" data-id="element-341">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-342">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8" data-id="element-343">
          <div className="flex flex-col items-center p-4 sm:p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-344">
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-3" data-id="element-345">
              <ClockIcon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-600" data-id="element-346" />
            </div>
            <div className="font-semibold text-sm sm:text-base md:text-lg text-center text-gray-800" data-id="element-347">
              Cenas en 15 minutos
            </div>
          </div>
          <div className="flex flex-col items-center p-4 sm:p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-348">
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-3" data-id="element-349">
              <ListIcon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-600" data-id="element-350" />
            </div>
            <div className="font-semibold text-sm sm:text-base md:text-lg text-center text-gray-800" data-id="element-351">
              Todo ya decidido
            </div>
          </div>
          <div className="flex flex-col items-center p-4 sm:p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-352">
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-3" data-id="element-353">
              <HeartIcon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-600" data-id="element-354" />
            </div>
            <div className="font-semibold text-sm sm:text-base md:text-lg text-center text-gray-800" data-id="element-355">
              Sin protestas familiares
            </div>
          </div>
          <div className="flex flex-col items-center p-4 sm:p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-356">
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-3" data-id="element-357">
              <SparklesIcon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-600" data-id="element-358" />
            </div>
            <div className="font-semibold text-sm sm:text-base md:text-lg text-center text-gray-800" data-id="element-359">
              Calma en lugar de caos
            </div>
          </div>
        </div>
      </div>
    </section>;
}